import React, { useEffect, useState, useMemo } from 'react';
import { Card, Modal, Row, Col } from 'react-bootstrap';
import ReactECharts from 'echarts-for-react';
import { fetchPeriodData } from 'hooks/CallApi';
import { isDemoMode } from 'data/demoMockData';

const UsageChart = ({ serviceType = 'sdk' }) => {
    // 컴포넌트 내부 상태
    const [usageRange, setUsageRange] = useState('monthly');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [chartData, setChartData] = useState({
        xAxisData: [],
        seriesData: []
    });

    // API에서 가져올 데이터를 위한 state 추가
    const [namespaces, setNamespaces] = useState([]);
    const [services, setServices] = useState([]);
    // 원본 API 데이터 저장을 위한 state 추가
    const [apiData, setApiData] = useState({ monthly: [], sixMonths: [] });

    // 모달 관련 상태 추가
    const [showModal, setShowModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedNamespaceData, setSelectedNamespaceData] = useState([]);
    // 컴포넌트 상단에 zoneId 추출
    const zoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('zoneId:', zoneId);

    // 블루 계열 색상 팔레트 정의
    const blueColorPalette = [
        '#2C7BE5', // Dark blue
        '#4A90E2', // Medium blue
        '#5AA9E6', // Lighter blue
        '#7BBDF5', // Even lighter blue
        '#A3D4F7', // Pale blue
        '#CFE9FB'  // Very light blue
    ];

    // 색상 선택 함수 - 블루 계열 색상 사용
    const getNamespaceColor = (namespaceName, nsData) => {
        const index = nsData.findIndex(ns => ns.name === namespaceName);
        return blueColorPalette[index % blueColorPalette.length];
    };

    // 서비스 색상 가져오기 함수 - 블루 계열 색상 사용
    const getServiceColor = (index, total = services.length) => {
        return blueColorPalette[index % blueColorPalette.length];
    };

    // // API 호출 및 데이터 로드 함수
    // const fetchUsageData = async (range) => {
    //     setLoading(false);
    //     setError(null);

    //     try {
    //         // API 호출하여 데이터 가져오기
    //         const response = await fetchPeriodData(zoneId);

    //         if (!response || !response.data) {
    //             throw new Error('데이터를 불러오는데 실패했습니다.');
    //         }

    //         const { monthly, sixMonths, services: apiServices, namespaces: apiNamespaces } = response.data;

    //         // 원본 API 데이터 저장 (상세 데이터 필터링에 사용)
    //         setApiData({ monthly: monthly || [], sixMonths: sixMonths || [] });

    //         // 네임스페이스/서비스 배열로 변환
    //         setNamespaces((apiNamespaces || []).map(name => ({ name })));
    //         setServices((apiServices || []).map(name => ({ name })));

    //         // 현재 선택된 범위에 따라 데이터 포맷팅
    //         let formattedData = {
    //             xAxisData: [],
    //             seriesData: []
    //         };

    //         if (range === 'monthly' && monthly) {
    //             // 날짜 정렬 (day: "YYYY-MM-DD")
    //             const sortedMonthlyData = [...monthly].sort((a, b) => new Date(a.day) - new Date(b.day));

    //             // 최근 28일만 사용
    //             const last28Days = sortedMonthlyData.slice(-28);

    //             // x축: 날짜
    //             formattedData.xAxisData = last28Days.map(item => {
    //                 const d = new Date(item.day);
    //                 return `${d.getMonth() + 1}/${d.getDate()}`;
    //             });

    //             // 네임스페이스별 시리즈
    //             formattedData.seriesData = (apiNamespaces || []).map(namespace => ({
    //                 name: namespace,
    //                 type: 'bar',
    //                 stack: 'total',
    //                 itemStyle: {
    //                     color: getNamespaceColor(namespace, apiNamespaces.map(n => ({ name: n })))
    //                 },
    //                 data: last28Days.map(item => {
    //                     // 객체에서 네임스페이스 데이터 추출
    //                     const nsData = item.namespaces?.[namespace];
    //                     return nsData ? nsData.usage : 0;
    //                 })
    //             }));
    //         } else if (range === '6months' && sixMonths) {
    //             // 월 정렬 (month: "YYYY-MM-01")
    //             const sortedMonths = [...sixMonths].sort((a, b) => new Date(a.month) - new Date(b.month));
    //             const last6Months = sortedMonths.slice(-6);

    //             formattedData.xAxisData = last6Months.map(item => {
    //                 const d = new Date(item.month);
    //                 return `${d.getMonth() + 1}월`;
    //             });

    //             formattedData.seriesData = (apiNamespaces || []).map(namespace => ({
    //                 name: namespace,
    //                 type: 'bar',
    //                 stack: 'total',
    //                 itemStyle: {
    //                     color: getNamespaceColor(namespace, apiNamespaces.map(n => ({ name: n })))
    //                 },
    //                 data: last6Months.map(item => {
    //                     const nsData = item.namespaces?.[namespace];
    //                     return nsData ? nsData.usage : 0;
    //                 })
    //             }));
    //         }

    //         setChartData(formattedData);
    //     } catch (err) {
    //         console.error('사용량 데이터 로드 실패:', err);
    //         setError(err.message || '데이터를 불러오는데 실패했습니다.');

    //         setChartData({
    //             xAxisData: [],
    //             seriesData: []
    //         });
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const generateDemoPeriodData = () => {
        const nsNames = ['production', 'staging'];
        const svcNames = serviceType === 'sdk'
            ? ['예/적금', '입출금', '가입자 생성/조회', '대출']
            : serviceType === 'cf'
                ? ['Cloud Function 호출', '배포 관리']
                : ['API Gateway', 'API 요청 처리'];
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        const monthly = [];
        for (let i = 27; i >= 0; i--) {
            const d = new Date(yesterday);
            d.setDate(d.getDate() - i);
            const dayStr = d.toISOString().split('T')[0];
            const nsObj = {};
            nsNames.forEach(ns => {
                const svcs = svcNames.map(name => ({
                    name,
                    usage: Math.floor(Math.random() * 200) + 50
                }));
                nsObj[ns] = { usage: svcs.reduce((s, v) => s + v.usage, 0), services: svcs };
            });
            monthly.push({ day: dayStr, namespaces: nsObj });
        }

        const sixMonths = [];
        for (let i = 5; i >= 0; i--) {
            const d = new Date(today);
            d.setMonth(d.getMonth() - i, 1);
            const monthStr = d.toISOString().split('T')[0];
            const nsObj = {};
            nsNames.forEach(ns => {
                const svcs = svcNames.map(name => ({
                    name,
                    usage: Math.floor(Math.random() * 5000) + 1000
                }));
                nsObj[ns] = { usage: svcs.reduce((s, v) => s + v.usage, 0), services: svcs };
            });
            sixMonths.push({ month: monthStr, namespaces: nsObj });
        }

        return { monthly, sixMonths, nsNames, svcNames };
    };

    useEffect(() => {
        setApiData({ monthly: [], sixMonths: [] });
        setNamespaces([]);
        setServices([]);
        setChartData({ xAxisData: [], seriesData: [] });

        if (isDemoMode()) {
            const demo = generateDemoPeriodData();
            setApiData({ monthly: demo.monthly, sixMonths: demo.sixMonths });
            setNamespaces(demo.nsNames.map(name => ({ name })));
            setServices(demo.svcNames.map(name => ({ name })));
            setLoading(false);
            return;
        }

        let cancelled = false;
        const fetchMonthly = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetchPeriodData(zoneId, 'daily', serviceType);
                if (!response || !response.data) throw new Error('데이터를 불러오는데 실패했습니다.');
                const { monthly, services: apiServices, namespaces: apiNamespaces } = response.data;
                if (!cancelled) {
                    setApiData(d => ({ ...d, monthly: monthly || [] }));
                    setNamespaces((apiNamespaces || []).map(name => typeof name === 'string' ? { name } : name));
                    setServices((apiServices || []).map(name => typeof name === 'string' ? { name } : name));
                }
            } catch (err) {
                if (!cancelled) setError(err.message || '데이터를 불러오는데 실패했습니다.');
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        fetchMonthly();
        return () => { cancelled = true; };
    }, [zoneId, serviceType]);

    useEffect(() => {
        if (isDemoMode()) return;

        let cancelled = false;
        const fetchSixMonths = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetchPeriodData(zoneId, 'monthly', serviceType);
                if (!response || !response.data) throw new Error('데이터를 불러오는데 실패했습니다.');
                const { sixMonths, services: newServices = [], namespaces: newNamespaces = [] } = response.data;
                if (!cancelled) {
                    setApiData(d => ({ ...d, sixMonths: sixMonths || [] }));
                    setServices(prev => {
                        const seen = new Set(prev.map(s => s.name));
                        (Array.isArray(newServices) ? newServices : []).forEach(ns => {
                            const name = typeof ns === 'string' ? ns : ns.name;
                            if (!seen.has(name)) seen.add(name);
                        });
                        return Array.from(seen).map(name => ({ name }));
                    });
                    setNamespaces(prev => {
                        const seen = new Set(prev.map(n => n.name));
                        (Array.isArray(newNamespaces) ? newNamespaces : []).forEach(nn => {
                            const name = typeof nn === 'string' ? nn : nn.name;
                            if (!seen.has(name)) seen.add(name);
                        });
                        return Array.from(seen).map(name => ({ name }));
                    });
                }
            } catch (err) {
                if (!cancelled) setError(err.message || '데이터를 불러오는데 실패했습니다.');
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        fetchSixMonths();
        return () => { cancelled = true; };
    }, [zoneId, serviceType]);

    // usageRange나 apiData가 바뀔 때 차트 데이터 가공
    useEffect(() => {
        setLoading(true);
        let formattedData = { xAxisData: [], seriesData: [] };

        if (usageRange === 'monthly') {
            // 어제 날짜 기준으로 x축(최근 28일)을 생성합니다.
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const last28DaysDates = [];
            for (let i = 27; i >= 0; i--) {
                const d = new Date(yesterday);
                d.setDate(d.getDate() - i);
                last28DaysDates.push(d);
            }
            formattedData.xAxisData = last28DaysDates.map(d => `${d.getMonth() + 1}/${d.getDate()}`);

            // 수신된 데이터를 날짜별로 조회하기 쉽게 Map으로 변환합니다.
            const dataMap = new Map();
            if (apiData.monthly && apiData.monthly.length > 0) {
                apiData.monthly.forEach(item => {
                    const d = new Date(item.day);
                    const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
                    dataMap.set(key, item.namespaces);
                });
            }

            formattedData.seriesData = namespaces.map(ns => ({
                name: ns.name,
                type: 'bar',
                stack: 'total',
                itemStyle: { color: getNamespaceColor(ns.name, namespaces) },
                data: last28DaysDates.map(d => {
                    const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
                    const dayData = dataMap.get(key);
                    return dayData?.[ns.name]?.usage || 0;
                })
            }));

        } else if (usageRange === '6months') {
            // 현재 날짜 기준으로 x축(최근 6개월)을 생성합니다.
            const today = new Date();
            const months = [];
            for (let i = 5; i >= 0; i--) {
                const d = new Date(today);
                d.setMonth(d.getMonth() - i, 1); // 날짜를 1일로 설정하여 월 건너뛰기 방지
                months.push({
                    year: d.getFullYear(),
                    month: d.getMonth() + 1,
                    key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`,
                    display: `${d.getMonth() + 1}월`
                });
            }
            formattedData.xAxisData = months.map(m => m.display);

            // 수신된 데이터를 월별로 조회하기 쉽게 Map으로 변환합니다.
            const dataMap = new Map();
            if (apiData.sixMonths && apiData.sixMonths.length > 0) {
                apiData.sixMonths.forEach(item => {
                    const d = new Date(item.month);
                    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
                    dataMap.set(key, item.namespaces);
                });
            }

            formattedData.seriesData = namespaces.map(ns => ({
                name: ns.name,
                type: 'bar',
                stack: 'total',
                itemStyle: { color: getNamespaceColor(ns.name, namespaces) },
                data: months.map(m => {
                    const monthData = dataMap.get(m.key);
                    return monthData?.[ns.name]?.usage || 0;
                })
            }));
        }

        setChartData(formattedData);
        setLoading(false);
    }, [usageRange, apiData, namespaces]);

    // 총 사용량 계산 함수
    const calculateTotalUsage = (usages) => {
        return usages.reduce((sum, usage) => sum + usage, 0);
    };

    // 파이 차트 옵션 생성 함수
    const generatePieChartOptions = (namespaceData) => {
        // 사용량이 0인 서비스는 이미 필터링되어 있음
        const hasData = namespaceData.services && namespaceData.services.length > 0;

        if (!hasData) {
            return {
                title: {
                    text: '사용량 없음',
                    left: 'center',
                    top: 'middle',
                    textStyle: {
                        color: '#999',
                        fontSize: 14,
                        fontWeight: 'normal'
                    }
                }
            };
        }

        return {
            tooltip: {
                trigger: 'item',
                formatter: '{b}: {c} 건 ({d}%)',
                backgroundColor: 'var(--falcon-quaternary-bg)',
                borderColor: 'var(--falcon-border-color)',
                borderWidth: 1,
                borderRadius: 6,
                textStyle: {
                    color: 'var(--falcon-body-color)'
                }
            },
            legend: {
                show: false
            },
            series: [
                {
                    name: namespaceData.namespace,
                    type: 'pie',
                    radius: namespaceData.services.length === 1 ? ['30%', '80%'] : ['40%', '70%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: namespaceData.services.length === 1 ? 8 : 5,
                        borderColor: '#fff',
                        borderWidth: namespaceData.services.length === 1 ? 2 : 1
                    },
                    label: {
                        show: false
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 15,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.3)',
                            scale: namespaceData.services.length === 1 ? 1.1 : 1.05
                        },
                        label: {
                            show: false
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: namespaceData.services.map((service, index) => ({
                        value: service.usage,
                        name: service.name,
                        itemStyle: {
                            color: getServiceColor(index, namespaceData.services.length)
                        }
                    }))
                }
            ]
        };
    };

    // 차트 옵션 생성 로직
    const usageChartOptions = useMemo(() => {
        const isDataEmpty = !chartData.seriesData.length ||
            chartData.seriesData.every(series => series.data.every(val => val === 0));

        const baseOptions = {
            tooltip: {
                trigger: 'axis',
                formatter: function (params) {
                    // 값이 0보다 큰 파라미터만 필터링
                    const validParams = params.filter(param => param.value > 0);

                    // 유효한 데이터가 없으면 툴팁을 표시하지 않음
                    if (validParams.length === 0) {
                        return '';
                    }

                    const total = validParams.reduce((sum, param) => sum + param.value, 0);
                    let tooltip = params[0].axisValueLabel + '<br/>';

                    validParams.forEach(param => {
                        tooltip += `<div style="display:flex;align-items:center;margin:3px 0;">
                            <div style="width:10px;height:10px;background-color:${param.color};margin-right:5px;"></div>
                            <span>${param.seriesName}: ${param.value.toLocaleString()} 건</span>
                        </div>`;
                    });

                    tooltip += `<div style="margin-top:5px;font-weight:bold;">총계: ${total.toLocaleString()} 건</div>`;
                    return tooltip;
                }
            },
            legend: {
                // 실제 시리즈 이름과 정확히 일치시키기 위해 series에서 추출
                data: Array.from(new Set((chartData.seriesData || []).map(s => s.name))),
                top: 0, // 범례를 상단에 배치
                type: 'scroll', // 네임스페이스가 많을 경우 스크롤 가능하도록
                pageIconColor: '#2C7BE5', // 페이지 아이콘 색상
                pageTextStyle: { color: '#2C7BE5' } // 페이지 텍스트 스타일
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '5%',
                top: '15%', // 상단 여백 추가 (범례 공간 확보)
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: chartData.xAxisData,
                axisLabel: {
                    rotate: usageRange === 'monthly' ? 0 : 45
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: value => value.toLocaleString() + ' 건'
                }
            },
            series: chartData.seriesData
        };

        // 데이터가 없는 경우 메시지 표시
        if (isDataEmpty) {
            return {
                ...baseOptions,
                title: {
                    text: loading ? '데이터 로딩 중...' : '데이터 없음',
                    left: 'center',
                    top: 'middle',
                    textStyle: {
                        color: '#999',
                        fontSize: 16,
                        fontWeight: 'normal'
                    }
                }
            };
        }

        return baseOptions;
    }, [chartData, loading, usageRange, namespaces]);

    // 범위 변경 핸들러
    const handleUsageRangeChange = (e) => {
        const newRange = e.target.value;
        setUsageRange(newRange);
        console.log(`사용량 범위 변경: ${newRange}`);
    };

    // 차트 바 클릭 핸들러
    const handleBarClick = (params) => {
        // params.name은 x축 라벨(예: "4/16" 또는 "5월")
        setSelectedDate(params.name);
        fetchDetailData(params.name, usageRange);
    };

    // 상세 데이터 가져오기 함수 - 저장된 API 데이터에서 필터링
    const fetchDetailData = (dateLabel, range) => {
        try {
            let selectedPeriodData;
            if (range === 'monthly') {
                // dateLabel: "4/16" 등
                const [month, day] = dateLabel.split('/').map(Number);
                selectedPeriodData = apiData.monthly.find(item => {
                    const d = new Date(item.day);
                    return d.getMonth() + 1 === month && d.getDate() === day;
                });
            } else {
                // dateLabel: "5월" 등
                const month = Number(dateLabel.replace('월', ''));
                selectedPeriodData = apiData.sixMonths.find(item => {
                    const d = new Date(item.month);
                    return d.getMonth() + 1 === month;
                });
            }

            if (!selectedPeriodData) {
                setSelectedNamespaceData([]);
                setShowModal(true);
                return;
            }

            // 네임스페이스별 서비스 사용량 구성 - 사용량이 있는 것들만 필터링
            const detailData = namespaces
                .map(namespace => {
                    // 객체에서 네임스페이스 데이터 추출
                    const nsData = selectedPeriodData.namespaces?.[namespace.name] || { services: [] };

                    // 사용량이 0보다 큰 서비스들만 필터링
                    const activeServices = services
                        .map(service => {
                            const svcData = nsData.services?.find(s => s.name === service.name);
                            return {
                                name: service.name,
                                usage: svcData?.usage || 0
                            };
                        })
                        .filter(service => service.usage > 0); // 사용량이 0보다 큰 것만

                    return {
                        namespace: namespace.name,
                        services: activeServices,
                        totalUsage: activeServices.reduce((sum, service) => sum + service.usage, 0)
                    };
                })
                .filter(nsData => nsData.totalUsage > 0); // 총 사용량이 0보다 큰 네임스페이스만

            setSelectedNamespaceData(detailData);
            setShowModal(true);
        } catch (err) {
            setError('상세 데이터를 로드하는데 실패했습니다.');
        }
    };

    return (
        <>
            <Card>
                <Card.Header>
                    <div className="row align-items-center g-0">
                        <div className="col">
                            <h4 className="mb-0">기간별 평균 사용량</h4>
                        </div>
                        <div className="col-auto">
                            <select
                                className="form-select form-select-sm"
                                value={usageRange}
                                onChange={handleUsageRangeChange}
                                disabled={loading}
                            >
                                <option value="monthly">최근4주</option>
                                <option value="6months">6개월간</option>
                            </select>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body style={{ height: '300px', padding: 0 }}>
                    {error && (
                        <div className="d-flex align-items-center justify-content-center h-100 text-danger">
                            <p>{error}</p>
                        </div>
                    )}
                    {!error && (
                        <div style={{ height: '100%', width: '100%' }}>
                            <ReactECharts
                                option={usageChartOptions}
                                style={{ height: '100%', width: '100%' }}
                                onEvents={{
                                    click: handleBarClick
                                }}
                            />
                        </div>
                    )}
                </Card.Body>
            </Card>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                size={(() => {
                    const namespaceCount = selectedNamespaceData.length;
                    if (namespaceCount === 0) return "lg";
                    if (namespaceCount === 1) return "lg";  // 1개면 lg
                    if (namespaceCount <= 2) return "xl";   // 2개면 xl
                    return "xl";                             // 3개 이상이면 xl
                })()}
                dialogClassName={(() => {
                    const namespaceCount = selectedNamespaceData.length;
                    if (namespaceCount >= 3) return "custom-modal-width";
                    return "";
                })()}
            >
                <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
                    <Modal.Title>
                        {usageRange === 'monthly'
                            ? `${selectedDate && selectedDate.includes('/')
                                ? selectedDate.replace('/', '월 ') + '일'
                                : new Date().getMonth() + 1 + '월 ' + (selectedDate || '')} 사용량`
                            : `${selectedDate || ''} 사용량`}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="py-3">
                    {Array.isArray(selectedNamespaceData) && selectedNamespaceData.length === 0 ? (
                        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '180px' }}>
                            <div className="text-muted mb-3">
                                <i className="fas fa-chart-bar fa-3x"></i>
                            </div>
                            <h5 className="text-muted">해당 기간에 사용량이 없습니다</h5>
                            <p className="text-muted mb-0">선택한 날짜/월에 활성화된 서비스가 없습니다.</p>
                        </div>
                    ) : (
                        <>
                            <Row className="gy-3 gx-3">
                                {Array.isArray(selectedNamespaceData) && selectedNamespaceData.map((namespaceData, index) => {
                                    const namespaceCount = selectedNamespaceData.length;
                                    const serviceCount = namespaceData.services.length;

                                    // 동적 컬럼 크기 계산
                                    let colSize;
                                    if (namespaceCount === 1) {
                                        colSize = 12; // 전체 너비 사용
                                    } else if (namespaceCount === 2) {
                                        colSize = 6;  // 반반
                                    } else {
                                        colSize = serviceCount <= 2 ? 4 : 6; // 서비스 개수에 따라 조정
                                    }

                                    return (
                                        <Col md={colSize} key={index} style={{
                                            borderRight: namespaceCount > 1 && index < selectedNamespaceData.length - 1 ? '1px dashed #ccc' : 'none',
                                            paddingRight: namespaceCount > 1 && index < selectedNamespaceData.length - 1 ? '24px' : '12px',
                                            paddingLeft: namespaceCount > 1 && index > 0 ? '24px' : '12px'
                                        }}>
                                            <div className="card-body py-3 px-3">
                                                {/* 통일된 레이아웃 - 서비스들을 가운데로 집약 */}
                                                <div className="row g-0 h-100 justify-content-center">
                                                    <div className="col-lg-8 col-md-9 order-1 order-sm-0">
                                                        <div className={`row g-sm-0 gy-4 row-cols-${serviceCount <= 2 ? '1' : serviceCount <= 4 ? '2' : '3'} h-100 align-content-center justify-content-center`}>
                                                            {namespaceData.services.map((service, serviceIndex) => (
                                                                <div className="col text-center" key={serviceIndex} style={{ marginBottom: '15px' }}>
                                                                    <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                                                                        <div
                                                                            className="rounded-circle"
                                                                            style={{
                                                                                width: '12px',
                                                                                height: '12px',
                                                                                backgroundColor: getServiceColor(serviceIndex)
                                                                            }}
                                                                        ></div>
                                                                        <h6 className="lh-base text-700 mb-0 text-truncate" style={{ maxWidth: '120px' }}>{service.name}</h6>
                                                                    </div>
                                                                    <h5 className="fw-semi-bold mb-1" style={{ fontSize: '1rem' }}>{service.usage.toLocaleString()}</h5>
                                                                    <small className="badge rounded-pill bg-primary">
                                                                        {((service.usage / calculateTotalUsage(namespaceData.services.map(s => s.usage))) * 100).toFixed(1)}%
                                                                    </small>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-3 mb-4 mb-sm-0 d-flex flex-column justify-content-center align-items-center">
                                                        <ReactECharts
                                                            option={generatePieChartOptions(namespaceData)}
                                                            style={{
                                                                height: '220px',
                                                                width: '100%',
                                                                maxWidth: '220px'
                                                            }}
                                                        />
                                                        <h6 className="mt-2 text-center fw-bold">{namespaceData.namespace}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default UsageChart;